module.exports = __webpack_public_path__ + "img/5.a05a514a.jpg";